import { favoritesAssignWidgetReducer } from '@cian/favorites-assign-widget';
import { combineReducers } from 'redux';

import {
  advicesReducer,
  blogsReducer,
  companyReducer,
  complainReducer,
  configReducer,
  noteReducer,
  offersReducer,
  pageReducer,
  questionsReducer,
  reviewsReducer,
  userReducer,
  vacanciesReducer,
  notificationsReducer,
} from '../slices';

export const reducer = combineReducers({
  company: companyReducer,
  config: configReducer,
  vacancies: vacanciesReducer,
  reviews: reviewsReducer,
  advices: advicesReducer,
  blogs: blogsReducer,
  questions: questionsReducer,
  offers: offersReducer,
  user: userReducer,
  favoritesAssignWidget: favoritesAssignWidgetReducer,
  complain: complainReducer,
  note: noteReducer,
  page: pageReducer,
  notifications: notificationsReducer,
});
